import * as React from 'react';
import Translate from '../../../common/functions/translate';
import MedicineService from '../../../services/medicineService';
import { InteractionsSummaryBasicModel } from '../../../models';
import InteractionsSummary from '../MedicineInteractions/interactionsSummary';
import DrugToDrugInteractions from '../MedicineInteractions/drugToDrugInteractions';
import DrugToFoodInteractions from '../MedicineInteractions/drugToFoodInteractions';
import DrugToDiseaseInteractions from '../MedicineInteractions/drugToDiseaseInteractions';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import Spinner from '../../../common/components/spinner/spinner';
import { Accordion, AccordionTab } from 'primereact/accordion';
import DrugInteractionsLegend from '../MedicineCommon/drugInteractionsLegend';
import { connect } from 'react-redux';

interface IProps {
  medicineId: any,
  history: any,
  match: any,
  lang: string
}

interface IState {
  isLoading: boolean;
  medicineId: number;
  error: any;
  interactionsSymmary: InteractionsSummaryBasicModel;
  activeIndex: any;
}

class interactionsTab extends React.Component<IProps, IState> {
  medicineService = new MedicineService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      isLoading: false,
      medicineId: this.props.medicineId,
      interactionsSymmary: new InteractionsSummaryBasicModel(),
      activeIndex: null
    };
  }

  componentDidMount() {
    this.getInteractionsCounts();
  }

  getInteractionsCounts = () => {
    this.setState({
      isLoading: true
    });

    this.medicineService.getInteractionsCountsBasic(this.state.medicineId, this.props.lang).then(
      (data: any) => {
        this.setState({
          isLoading: false,
          interactionsSymmary: data.data
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  handleTabMenuchange = (event, value) => {
    if (value != null) {
      this.setState({ activeIndex: value });
    } else {
      this.setState({ activeIndex: null });
    }
  }

  public render() {
    const { isLoading, error, interactionsSymmary, activeIndex } = this.state;

    let interactionsContentElement: any;
    if (interactionsSymmary && interactionsSymmary.medicineInteractionsContent) {
      interactionsContentElement = <div dangerouslySetInnerHTML={{ __html: interactionsSymmary.medicineInteractionsContent }}></div>
    }

    return (
      <div>
        {isLoading ? <Spinner /> : null}
        {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}

        {interactionsContentElement}

        <Accordion activeIndex={activeIndex} onTabChange={(e) => this.handleTabMenuchange(e, e.index)}>
          <AccordionTab header={Translate('DrugInteractions') + ' (' + interactionsSymmary.allDrugsInteractionsCount + ')'}>
            {activeIndex == 0 ?
              <>
                <DrugToDrugInteractions medicineId={this.props.medicineId} history={this.props.history} />
              </>
              : null}
          </AccordionTab>
          <AccordionTab header={Translate('DiseaseInteractions') + ' (' + interactionsSymmary.allDiseaseInteractionsCount + ')'}>
            {activeIndex == 1 ?
              <>
                <DrugToDiseaseInteractions medicineId={this.props.medicineId} history={this.props.history} />
              </>
              : null}
          </AccordionTab>
          <AccordionTab header={Translate('Alcohol/FoodInteractions') + ' (' + interactionsSymmary.allAlcoholFoodInteractionsCount + ')'}>
            {activeIndex == 2 ?
              <>
                <DrugToFoodInteractions medicineId={this.props.medicineId} history={this.props.history} />
              </>
              : null}
          </AccordionTab>
        </Accordion>
        <DrugInteractionsLegend />

      </div>
    )
  }
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang
  };
}

export default connect(mapsStateToProps, null)(interactionsTab);

//export default interactionsTab;
